module.exports = __webpack_public_path__ + "static/media/hero_250x250.b602ad67.jpg";